var loadedMaps = {};
var openingMap = false;
var openingSingleMap = false;
var mapBox;
tpj.extend({
    offerList: new function () {
        var self = this;
        var container;
        var pager = null;
        var proccessAvailReq;
        var executing = false;

        self.initialize = function (attach, proccess) {
            container = tpj('#offers-list-container');

            if (attach)
                attachBehaviour();

            if (proccess.toString().toLowerCase() == "true")
                proccessAvailability();
            else if (proccess.toString().toLowerCase() == "loadfilters") {
                loadAdjustFilters("GetAdjustFiltersDirectory", "SessionState");
                loadPager();
            }
            else if (proccess.toString().toLowerCase() == "loadfiltersfavorits") {
                loadAdjustFilters("GetAdjustFiltersFavorits", "Public");
                loadPager();
            }
            else if (typeof tpj.adjustSearch != "undefined") {
                pager = new Pager();
                pager.initialize();
                tpj.adjustSearch.initialize();
            } else {
                pager = new Pager();
                pager.initialize();
            }

            
            self.initializeFavorites();

            //Review Slider
            initPopoverReviews();

            //Credit Calculator
            if (typeof pmtSimulator !== typeof undefined && pmtSimulator && pmtSimulator.simulator_app && tpj('.PmtSimulator').length > 0) {
                pmtSimulator.simulator_app.setPublicKey(PAGAMASTARDE_PUBLICKEY);
                pmtSimulator.simulator_app.init();
            }

            //Lazy Loading
            echo.init({
                offset: 200,
                throttle: 250,
                unload: false
            });

        };

        self.refreshFilters = function (showPriceSlider) {
            tpj.ajax({
                url: Environment_APP_PATH + "Public/GetAdjustSearchFiltersView",
                type: 'get',
                data: { showPriceSlider: showPriceSlider },
                success: function (data) {
                    tpj('#adjust-search').html(data);
                    tpj.adjustSearch.initialize();
                    tpj('#adjust-search dt').each(function () {
                        var tis = tpj(this), state = false, answer = tis.next('dd').hide().css('height', 'auto').slideUp();
                        tis.click(function () {
                            state = !state;
                            answer.slideToggle(state);
                            tis.toggleClass('active', state);
                        });
                    });
                }
            });
        }

        self.initializeFavorites = function () {
            tpj(".btn-favorite").click(function () {
                self.addToFavorite(tpj(this).data('hotelid'));
            });

            tpj(".btn-favorite-remove").click(function () {
                self.removeFromFavorite(tpj(this).data('hotelid'));
            });
        }

        var proccessAvailability = function () {

            proccessAvailReq = tpj.ajax({
                type: "POST", url: Environment_APP_PATH + "Core/ProccessAvailability",
                cache: false,
                dataType: "json",
                success: function (data) {
                    
                    loadAdjustFilters("GetAdjustFilters", "Public");
                    loadPager(false);
                },
                error: function () {
                    if(proccessAvailReq != null)
                        proccessAvailReq.abort();
                }
            });
            
        };

        self.addToFavorite = function (hotelId) {

            if (!executing) {

                executing = true;

                
                tpj('#overlay2').splash({
                    title: LOCALIZATIONS.AddingToFavorites + '...'
                });
                tpj('#overlay2').splash('show');


                tpj.ajax({
                    type: "POST", url: Environment_APP_PATH + "public/add-to-favorite",
                    cache: false, data: {
                        hotelId: hotelId
                    }, dataType: "json",
                    success: function (data) {
                        tpj('#overlay2').splash('hide');

                        executing = false;

                        if (data.Success) {
                            //if (!tpj(".menu").hasClass(" menu-left")) {
                            //    tpj(".menu").addClass(" menu-left");
                            //}
                            //tpj(".menu .favorit").removeClass("hidden");
                            //tpj(".favorits-summary #favorits-count").html(data.Count);
                            //tpj(".favorits-summary .link-image").attr("href", Environment_APP_PATH + "favoritos");
                            //tpj(".favorits-summary .link").attr("href", Environment_APP_PATH + "favoritos");
                            reloadTopBar();
                            MessageBox.error("Operación correcta", "¡Hotel añadido a favoritos!");
                        }
                        else {
                            MessageBox.error("Operación fallida", data.ErrorMsg);
                        }
                    },
                    error: function () {
                        tpj('#overlay2').splash('hide');
                    }
                });

            }
        }

        self.removeFromFavorite = function (hotelId) {

            if (!executing) {
                executing = true;

                tpj('#overlay2').splash({
                    title: LOCALIZATIONS.RemovingFromFavorites + '...'
                });
                tpj('#overlay2').splash('show');



                tpj.ajax({
                    type: "POST", url: Environment_APP_PATH + "public/remove-to-favorite",
                    cache: false, data: {
                        hotelId: hotelId
                    }, dataType: "json",
                    success: function (data) {
                        tpj('#overlay2').splash('hide');

                        executing = false;

                        if (data.Success) {
                            //if (!tpj(".menu").hasClass(" menu-left")) {
                            //    tpj(".menu").addClass(" menu-left");
                            //}
                            //tpj(".menu .favorit").removeClass("hidden");
                            //tpj(".favorits-summary #favorits-count").html(data.Count);
                            //tpj(".favorits-summary .link-image").attr("href", Environment_APP_PATH + "favoritos");
                            //tpj(".favorits-summary .link").attr("href", Environment_APP_PATH + "favoritos");
                            reloadTopBar();
                            MessageBox.error("Operación correcta", "¡Hotel eliminado de favoritos!");
                        }
                        else {
                            MessageBox.error("Operación fallida", data.ErrorMsg);
                        }
                    },
                    error: function () {
                        tpj('#overlay2').splash('hide');
                    }
                });
            }
        }

        var loadPager = function (initHidden) {

            if (typeof (initHidden) == "undefined") {
                initHidden = true;
            }

            tpj.get(Environment_APP_PATH + "Public/GetPager?actionName=" + tpj('#action-name').val()+"&initHidden="+initHidden, function (data) {
                tpj('#pager-wrapper').html(data);

                pager = new Pager();
                pager.initialize();

                tpj('.pager').removeClass('hide');
                tpj('.pager-loading-message').remove();

                tpj("#offers-list-count").html(tpj("#num-hoteles").val());
                tpj('.num-results-place').text(tpj("#num-hoteles").val());
                tpj('.results-breadcrumb').text(tpj("#num-hoteles").val());

            });
        }

        var loadAdjustFilters = function (action, controller) {

            tpj.get(Environment_APP_PATH + controller+"/" + action+"?"+tpj('#directory-parameters').val(), function (data) {
                tpj('#adjust-search').html(data);
                tpj.adjustSearch.initialize();
                tpj('#adjust-search dt').each(function () {
                    var tis = tpj(this), state = false, answer = tis.next('dd').hide().css('height', 'auto').slideUp();
                    tis.click(function () {
                        state = !state;
                        answer.slideToggle(state);
                        tis.toggleClass('active', state);
                    });
                });
                if (tpj('#adjust-search input[type=checkbox]:checked').size() > 0 ||
                    tpj.trim(tpj('#adjust-search input:text').val()) != "") {
                    tpj.adjustSearch.filter("Filtrando resultados...");
                }
                
            });
        };

        var attachBehaviour = function () {

            tpj(".slide_button", container).click(function () {
                tpj(this).parent().siblings('.' + tpj(this).data('type')).slideToggle("slow");
                tpj(this).toggleClass("minus_icon");

                if (tpj(this).is(".minus_icon")) {
                    tpj(this).html("Ver menos &#9650;");
                } else {
                    tpj(this).html("Ver "+tpj(this).data('count')+" tipos más de habitación disponibles  &#9660;");
                }

                return false;
            });

            tpj(".bookbtn-action", container).click(function () {

                

                var link = tpj(this).data('directlink');
                var hotelId = tpj(this).parents(".offer-item").first().data("hotelid");

                if (tpj.trim(link) != "") {

                    var priceBlocked = tpj(this).data('price');

                    var hotelDirectId = tpj(this).parents(".offer-item").first().data("hoteldirectid");

                    var _url = "";
                    var _text = "";

                    if (hotelDirectId && hotelDirectId != "0") {
                        _url = Environment_APP_PATH + "Core/HotelRedirect?hd=" + hotelDirectId + "&priceBlocked=" + priceBlocked.replace(",", ".") + "&url=" + encodeURIComponent(link);
                        _text = LOCALIZATIONS.HotelDirectRedirectText;
                    } else {
                        _url = Environment_APP_PATH + "Core/ExternalHotelRedirect?serviceCode=" + hotelId + "&priceBlocked=" + priceBlocked.replace(",", ".") + "&url=" + encodeURIComponent(link)
                    }

                    var win = window.open(_url, "Title", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=" + (tpj(window).width() / 2) + ", height=" + (tpj(window).height() - 50) + ", top=10, left=10");

                    tpj('#overlay').splash({
                        showSearchSummary: false,
                        showBannerSlider: false,
                        text: _text
                    });
                    
                    win.document.body.innerHTML = '<link href="' + ASSETS_DOMAIN + '/Content/dist/css/bootstrap.css" rel="stylesheet" media="screen"><link href="' + ASSETS_DOMAIN + '/Content/assets/css/custom.css" rel="stylesheet" media="screen">	<style>#overlay .modal-content{min-height:500px;padding-top:30px}</style><div id="overlay">' + tpj('#overlay').splash('get') + "</div>";
                    //window.location.assign(Environment_APP_PATH + "Core/HotelRedirect?hd=" + hotelDirectId + "&priceBlocked=" + priceBlocked.replace(",", ".") + "&url=" + encodeURIComponent(link));
                } else {

                    tpj('#overlay2').splash({
                        title: LOCALIZATIONS.BlockHotelLoadingText + '...'
                    });
                    tpj('#overlay2').splash('show');


                    
                    var roomId = tpj(this).data("roomid");
                    var distributionId = tpj(this).data("distributionid");

                    tpj.ajax({
                        type: "POST", url: Environment_APP_PATH + "reservation/add-to-cart",
                        cache: false, data: {
                            hotelId: hotelId,
                            roomId: roomId,
                            distributionId: distributionId
                        }, dataType: "json",
                        success: function (data) {


                            if (data.Success) {
                                window.location.href = Secure_Domain + "confirmar-y-pagar";
                            }
                            else if (data.IsJrSessionExpired) {
                                tpj('#overlay2').splash('hide');
                                MessageBox.alert("Sessión Expirada", data.ErrorMsg,
                                {
                                    props: {
                                        text: "Buscar disponibilidad",
                                        click: function () {
                                            tpj(this).dialog("close");

                                            tpj.homeSearch.searchAvailability();
                                        }
                                    }
                                });
                            }
                            else {
                                tpj('#overlay2').splash('hide');
                                MessageBox.error("Reserva fallida", data.ErrorMsg);
                            }
                        },
                        error: function () {
                            tpj('#overlay2').splash('hide');
                        }
                    });

                }
            });

            tpj('.show-in-map, .show-in-map-mobile').click(function () {
                loadMapAllHotels();
            });

            
        };
    }
});

function UpdateMetas(zone, hotels) {

    //title
    var str = jQuery.validator.format('Ofertas especiales de hoteles y paquetes en {0}. Mejor precio garantizado, descuentos, ofertas de temporada', zone);
    SetOrCreateMetaTag('title', str);
    document.title = str;

    //description
    if (hotels != null && hotels.length > 0) {
        str = jQuery.validator.format('{0}', hotels);
        SetOrCreateMetaTag('description', str);
    }

    //Keywords
    var t = jQuery.validator.format('meta[name={0}]', 'Keywords');
    var mt = tpj(t);
    if (mt.length == 1) {
        str = jQuery.validator.format('{0}, {1}, {2}', mt.attr('content'), zone, hotels);
        SetOrCreateMetaTag('Keywords', str);
    } else {
        SetOrCreateMetaTag('Keywords', zone + ',' + hotels);
    }
}

function SetOrCreateMetaTag(name, value) {
    var t = jQuery.validator.format('meta[name={0}]', name);
    var mt = tpj(t);
    if (mt.length == 0) {
        t = jQuery.validator.format('<meta name={0} content={1} />', name, value);
        tpj(t).appendTo('head');
    }
    else {
        mt.attr('content', value);
    }
}

function showAditionalInfoOnModal(id) {
    tpj("#" + id).dialog({
        modal: true,
        buttons: {
            Ok: function () {
                tpj(this).dialog("close");
            }
        }
    });
    tpj("#" + id).dialog("open");
}

function loadMap(id, alwaysShow, openTab) {

    if (!openingSingleMap) {

        openingSingleMap = true;

        if (openTab) {
            showHotelTabs(id);
            tpj('#HotelTabs-' + id + ' .nav-tabs a[href=#maps-' + id + ']').tab('show');
            tpj('#HotelTabs-' + id + ' .nav-tabs a[href=#maps-' + id + ']').parent().trigger('click');
            tpj('#HotelTabs-' + id + ' .tab-pane.active').removeClass('active');

            tpj('#HotelTabs-' + id + ' #maps-' + id).addClass('active in');

            mySelectUpdate();
        }

        if (loadedMaps[id]) {
            //El mapa ya ha sido cargado. Solo lo mostramos / ocultamos.
            if (alwaysShow) {
                tpj('#map-' + id).slideDown(500, '', function () {
                    openingSingleMap = false;
                    tpj('body,html').animate({
                        scrollTop: tpj('#map-' + id).offset().top - 250
                    }, 800);
                });
            } else {
                tpj('#map-' + id).slideToggle(500, '', function () {
                    openingSingleMap = false;
                    tpj('body,html').animate({
                        scrollTop: tpj('#map-' + id).offset().top - 250
                    }, 800);
                });
            }
        } else {

            //El mapa no ha sido cargado. Lo cargamos por 1ª vez.


            tpj('#map-' + id).slideToggle(500, '', function () {




                var lat, lng, secheltLoc;

                lat = tpj('#map-' + id).data('lat');

                lng = tpj('#map-' + id).data('lng');

                secheltLoc = new google.maps.LatLng(lat, lng);

                var myMapOptions = {
                    zoom: 15
                    , center: secheltLoc
                    , mapTypeId: google.maps.MapTypeId.ROADMAP
                };
                var theMap = new google.maps.Map(document.getElementById("map-" + id), myMapOptions);


                var marker = new google.maps.Marker({
                    map: theMap,
                    draggable: false,
                    position: new google.maps.LatLng(lat, lng),
                    visible: true
                });



                var boxText = document.createElement("div");

                boxText.innerHTML = tpj('#mapContent-' + id).html();

                var myOptions = {
                    content: boxText
                    , disableAutoPan: false
                    , maxWidth: 150
                    , pixelOffset: new google.maps.Size(-90, -30)
                    , zIndex: null
                    , alignBottom: true
                    , infoBoxClearance: new google.maps.Size(1, 1)
                    , isHidden: false
                    , pane: "floatPane"
                    , enableEventPropagation: false
                    , closeBoxMargin: "0",
                    closeBoxURL: "http://www.google.com/intl/en_us/mapfiles/close.gif",
                };

                google.maps.event.addListener(marker, "click", function (e) {
                    var ib = new InfoBox(myOptions);
                    ib.open(theMap, this);
                });

                google.maps.event.addDomListener(window, "resize", function () {
                    var center = theMap.getCenter();
                    google.maps.event.trigger(theMap, "resize");
                    theMap.setCenter(center);
                });

                //ib.open(theMap, marker);

                //Marcamos el mapa como cargado para no cargarlo de nuevo.
                loadedMaps[id] = true;

                openingSingleMap = false;

                tpj('body,html').animate({
                    scrollTop: tpj('#map-' + id).offset().top - 250
                }, 800);

            });
        }

    }

}

function loadMapAllHotels() {

    tpj('#filter-overlay').css('height', tpj('body').height() + 'px').fadeIn();

    tpj('body,html').animate({
        scrollTop: tpj('#map-all').offset().top - 100
    }, 800);

    if (loadedMaps["all"]) {
        //El mapa ya ha sido cargado. Solo lo mostramos / ocultamos.
        if (!openingMap) {
            openingMap = true;
            tpj('#map-all').slideToggle(500, function () {
                openingMap = false;
            });
        }
            //tpj('#offers-list').hide();
        
    } else {
        //El mapa no ha sido cargado. Lo cargamos por 1ª vez.

        //Lanzamos peticion AJAX para obtener las localizaciones
        //de todos los hoteles obtenidos.

        var locationData = null;

        tpj.ajax({
            type: "POST",
            url: Environment_APP_PATH + "core/get-hotel-locations",
            cache: false,
            dataType: "json",
            success: function (data) {
          

                if (data.Success) {
                    locationData = data.Hotels;

                    //tpj('#offers-list').hide();
                    tpj('#map-all').slideDown(500, '', function () {

                        var lat, lng;

                        lat = locationData[0].Lat;

                        lng = locationData[0].Lng;

                        var secheltLoc = new google.maps.LatLng(lat, lng);
                        var myMapOptions = {
                            zoom: 8,
                            center: secheltLoc,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        };
                        var theMap = new google.maps.Map(document.getElementById("map-all"), myMapOptions);

                        var newMarkers = [],
                                marker;

                        for (var i in locationData) {



                            secheltLoc = new google.maps.LatLng(lat, lng);

                            lat = locationData[i].Lat;

                            lng = locationData[i].Lng;


                            marker = new google.maps.Marker({
                                map: theMap,
                                draggable: false,
                                position: new google.maps.LatLng(lat, lng),
                                visible: true
                            });

                            var boxText = document.createElement("div");
                            var innerHTML = "<div class='map-box-wrap'>";
                            innerHTML += "<h3>" + locationData[i].Name + " <div class='ratingdiv c-" + locationData[i].CategoryImgPath + "'></div></h3>";
                            innerHTML += "<p>" + locationData[i].Address + "</p>";
                            innerHTML += "<p>" + locationData[i].Description + "</p>";
                            innerHTML += "<p><a class='btn btn-success' href='" + Environment_APP_PATH + "detalles-hotel/" + locationData[i].Url + "'>" + LOCALIZATIONS.MoreDetails + "</p>";
                            innerHTML += "</div>";
                            boxText.innerHTML = innerHTML;
                            //boxText.style.cssText = "border: 1px solid black; margin-top: 8px; background: yellow; padding: 5px;";

                            var infoboxOptions = {
                                content: boxText
                                , disableAutoPan: false
                                , maxWidth: 150
                                , pixelOffset: new google.maps.Size(-90, -30)
                                , zIndex: null
                                , alignBottom: true
                                , infoBoxClearance: new google.maps.Size(1, 1)
                                , isHidden: false
                                , pane: "floatPane"
                                , enableEventPropagation: false
                                , closeBoxMargin: "0",
                                closeBoxURL: "http://www.google.com/intl/en_us/mapfiles/close.gif",
                            };

                            newMarkers.push(marker);

                            newMarkers[i].infobox = new InfoBox(infoboxOptions);

                            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                                return function () {
                                    for (h = 0; h < newMarkers.length; h++) {
                                        newMarkers[h].infobox.close();
                                    }
                                    newMarkers[i].infobox.open(theMap, this);
                                    //theMap.panTo(secheltLoc);
                                }
                            })(marker, i));



                        }
                        //Marcamos el mapa como cargado para no cargarlo de nuevo.
                        loadedMaps['all'] = true;

                    });


                }
                else {
                    MessageBox.error("Operación fallida", data.ErrorMsg);
                }
            },
            error: function () {
                
            }
        });



    }

    tpj('#filter-overlay').fadeOut();
}

function addToFavorite(hotelId) {
    tpj.offerList.addToFavorite(hotelId);
}

function initPopoverReviews() {
    tpj('a.popover-reviews').popover({
        "html": true,
        "placement": "bottom",
        "content": function () {
            var $this = tpj(this);
            var div_id = "reviews-popover-placeholder-" + $this.data('hid').replace("|", "");
            tpj.ajax({
                url: '/Public/GetHotelReviews',
                data: { hotelCode: $this.data('hid') },
                success: function (response) {
                    tpj("#" + div_id).html(response);

                    tpj("#" + div_id).find(".reviews-carousel-container").each(function () {

                        tpj(this).owlCarousel({
                            autoplay: true,
                            autoplayTimeout: 7000,
                            autoplayHoverPause: true,
                            items: 1,
                            itemsDesktop: [1199, 1],
                            itemsDesktopSmall: [980, 1],
                            itemsTablet: [768, 1],
                            itemsTabletSmall: false,
                            itemsMobile: [479, 1],
                            rewindNav: false,
                            navigation: true,
                            navigationText: [
                            "<i class='fa fa-chevron-left icon-white'></i>",
                            "<i class='fa fa-chevron-right icon-white'></i>"
                            ],
                            responsive: true,
                            responsiveRefreshRate: 200,
                            responsiveBaseWidth: window,
                            pagination: false
                        });

                    });

                    tpj("#" + div_id).find('button.close').click(function () {
                        $this.popover('hide');
                        tpj("#" + div_id).parents('.popover').eq(0).hide();
                    })

                    tpj('html').on('mouseup', function (e) {
                        if (!tpj(e.target).closest('.popover').length) {
                            tpj('.popover').each(function () {
                                tpj(this.previousSibling).popover('hide');
                                tpj(this).hide();
                            });
                        }
                    });


                }
            });
            return '<div id="' + div_id + '" class="text-center reviews-popover-placeholder"><img src="' + ASSETS_DOMAIN + '/Content/images/loader.gif" alt="Loading..." /></div>';
        }
    });

    tpj('img.review-img-summary').click(function () {
        tpj(this).parents('.offer-item').eq(0).find('a.popover-reviews').trigger('click');
    })
}

			
tpj(function () {
    //Scarcity
    if (tpj(".availmeter").length > 0) {
        setTimeout(function () {
            tpj(".availmeter").show(1000);
            var percent = tpj('.availmeter .percent').text();
            var newVal = percent * 3.6 / 2;
            if (percent >= 50 && percent < 65) {
                tpj('.availmeter .alert-warning').css({ "backgroundColor": "#eee" });
                tpj('.availmeter ').append('<style>.semi-circle::before{background-color:#eee;}</style>');
                //tpj('.availmeter').append('<style>.availmeter strong::before{content:"Ocupación alta y subiendo";}</style>');
                //tpj('.availmeter').append('<style>.availmeter .panic::before{content:"cuanto antes!";}</style>');
            }
            else if (percent >= 65 && percent < 80) {
                tpj('.availmeter .alert-warning').css({ "backgroundColor": "#fcf8e3" });
                tpj('.availmeter ').append('<style>.semi-circle::before{background-color:fcf8e3;}</style>');
                //tpj('.availmeter').append('<style>.availmeter strong::before{content:"Ocupación muy alta y subiendo";}</style>');
                //tpj('.availmeter').append('<style>.availmeter .panic::before{content:"ya para no quedarte sin reserva!";}</style>');
            }
            else if (percent >= 80 && percent < 90) {
                tpj('.availmeter .alert-warning,.semi-circle::before').css({ "backgroundColor": "#FB8158" });
                tpj('.availmeter .alert-warning').css({ "color": "#fff" });
                tpj('.availmeter ').append('<style>.semi-circle::before{background-color:#FB8158;}</style>');
                //tpj('.availmeter').append('<style>.availmeter strong::before{content:"¡Altísima ocupación!";}</style>');
                //tpj('.availmeter').append('<style>.availmeter .panic::before{content:"de inmediato para no quedarte sin reserva!";}</style>');
            }
            else if (percent >= 90) {
                tpj('.availmeter .alert-warning,.semi-circle::before').css({ "backgroundColor": "#FB5955" });
                tpj('.availmeter .alert-warning').css({ "color": "#fff" });
                tpj('.availmeter ').append('<style>.semi-circle::before{background-color:#FB5955;}</style>');
                //tpj('.availmeter').append('<style>.availmeter strong::before{content:" ¡Últimas plazas y hoteles disponibles!";}</style>');
                //tpj('.availmeter').append('<style>.availmeter .panic::before{content:"enseguida porque es un destino muy demandado!";}</style>');
            }
            tpj('.meter .semi-circle-mask').attr({
                style: '-webkit-transform: rotate(' + newVal + 'deg);' +
                '-moz-transform: rotate(' + newVal + 'deg);' +
                'transform: rotate(' + newVal + 'deg);'
            });
        }, 1000);
    }

    tpj('.mobileshare').click(function (e) {
        tpj('.social-sidebar').toggle();
    });
    tpj('.changedate').click(function (e) {
        tpj('.bookfilters').toggle();
        location.href = '#bookfilters';
        window.scrollTo(0,0);
        if (tpj('#adjust-search').css('display') == 'block') {
            tpj('#adjust-search').css({ 'display': 'none' });
        }
    });
    tpj('.mobilefilter').click(function (e) {
        tpj('#adjust-search').toggle();
        location.href = '#adjust-search';
        window.scrollTo(0, 0);
        if (tpj('.bookfilters').css('display') == 'block') {
            tpj('.bookfilters').css({ 'display': 'none' });
        }

    });
    if (tpj('.mobilesearchsum').length > 0) {
        var sticky_navigation_offset_top = tpj('.mobilesearchsum').offset().top;
        var sticky_navigation = function () {
            /*var scroll_top = tpj(window).scrollTop();

            if (scroll_top > sticky_navigation_offset_top) {
                tpj('.mobilesearchsum').css({ 'position': 'fixed', 'top': 50, 'left': 0, 'box-shadow': '1px 1px 1px 0 rgba(1,2,1,.3)' });
                tpj('.onlyintop').css({ 'display': 'inline-flex' });
                tpj('.mobilesearchsum a').css({ 'display': 'none' });
            } else {
                tpj('.mobilesearchsum').css({ 'position': 'relative', 'top': 0 });
                tpj('.onlyintop').css({ 'display': 'none' });
                tpj('.mobilesearchsum a').css({ 'display': 'block' });
            }*/
            tpj('.mobilesearchsum').css({ 'position': 'fixed', 'top': 50, 'left': 0, 'box-shadow': '1px 1px 1px 0 rgba(1,2,1,.3)' });
            tpj('.onlyintop').css({ 'display': 'inline-flex' });
            tpj('.mobilesearchsum a').css({ 'display': 'none' });
        };
        sticky_navigation();
        /*tpj(window).scroll(function () {
            sticky_navigation();
        });*/
    }
});
